import { createStore, applyMiddleware } from "redux"
import { composeWithDevTools }          from "redux-devtools-extension"
import createSagaMiddleware             from "redux-saga"
import thunk                            from "redux-thunk"

import createRootReducer from "./reducers/index"

export default function configureStore(initialState) {
  const SagaMiddleware    = createSagaMiddleware()

  return {
    ...createStore(
      createRootReducer(),
      initialState,
      composeWithDevTools(
        applyMiddleware(SagaMiddleware),
        applyMiddleware(thunk)
      )
    ),
    runSaga: SagaMiddleware.run
  }
}
